import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { apiClient } from "@finitless/shared/lib";
import { userInfo } from "@finitless/shared/stores";

/**
 * Hook to fetch user API keys
 * @returns {Object} Query result with API keys
 */
export const useApiKeys = () => {
  const user = userInfo();

  return useQuery({
    queryKey: ["apiKeys", user?.id],
    queryFn: async () => {
      const response = await apiClient.get(`/users/${user?.id}/keys`);
      return response?.result || [];
    },
    enabled: !!user?.id,
    staleTime: 5 * 60 * 1000, // 5 minutes
    refetchOnWindowFocus: false,
    refetchOnMount: true,
    refetchOnReconnect: false,
    retry: false,
  });
};

/**
 * Hook to create a new API key
 * @returns {Object} Mutation object
 */
export const useCreateApiKey = () => {
  const user = userInfo();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async () => {
      const response = await apiClient.post(`/users/${user?.id}/keys`);
      return response?.result;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["apiKeys", user?.id] });
    },
  });
};

export default {
  useApiKeys,
  useCreateApiKey,
};
